import { isEmpty } from "lodash-es";

import { useOwlStore } from "../stores/owl.store";

export const useTranslatedProperty = <T>(obj: T | undefined, propName: keyof T, translationDictProp: keyof T) => {
    const lng = useOwlStore().config.lng;
    if (lng === "en") {
        return obj?.[propName];
    }

    const translatedPropValue = obj?.[translationDictProp as string]?.[lng];

    return isEmpty(translatedPropValue) ? obj?.[propName] : translatedPropValue;
};
